import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';

import { FcSelectComponent } from './fc-select/fc-select.component';
import { FcProgressSpinnerModule } from './fc-progress-spinner/fc-progress-spinner.module';

const components = [FcSelectComponent];
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatBadgeModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatToolbarModule,
        FcProgressSpinnerModule
    ],
    declarations: components,
    exports: components
})
export class UiComponentsModule {}
